<!-- Show Auth Selection when NOT logged in -->
<app-auth-selection *ngIf="!(loggedIn$ | async)"></app-auth-selection>

<!-- Show Dashboard when logged in -->
<div *ngIf="loggedIn$ | async">


  <app-page-header
    title="Dashboard"
    subtitle="Willkommen zurück! Hier ist deine Übersicht."
    icon="analytics"
    variant="gradient">
  </app-page-header>
    <!-- Main Content Grid -->
    <div class="nlc-container nlc-slide-up">
      <app-coin-widget></app-coin-widget>
      
      <!-- Quick Actions -->
      <div class="quick-actions">
        <button class=" nlc-button nlc-button-primary nlc-button-large" (click)="goToTransactions()">
          <mat-icon>account_balance_wallet</mat-icon>
          <span>Meine Transaktionen</span>
          <mat-icon class="arrow-icon">arrow_forward</mat-icon>
        </button>
      </div>
    </div>
  </div>
